<script setup>
import { useBootstrapModal } from "@/composables/useBootstrapModal";
import {
    useAuthStore
} from "@/store/auth";
import AddReviowModal from '~/components/addReviowModal.vue'
import { useWarningModal } from "~/composables/useWarningModal";
const { showModal } = useWarningModal();

const formsRepo = formsRepository();

const authStore = useAuthStore();
const isAuthenticated = computed(() => authStore.isAuthenticated);
const user = computed(() => authStore.user);

const { openModal: openUserModal } = useBootstrapModal("userModal");
const { openModal: openRateModal } = useBootstrapModal("add_rate_modal");
const props = defineProps({
  place: { type: Object, required: true },
  avatarUrl: { type: String, required: true },
  cleanedStoreLink: { type: String, default: '' }
})


const showIsRatedWaringModal = () => {
showModal('لقد قمت بالتقييم مسبقاً','لقد قمت بالتقييم مسبقاً');
};

const addReviowModal = ref()

const openAddRateModal = (placeId) => {
  
  // Set the place id in the modal component using the exposed method.
  if (addReviowModal.value && addReviowModal.value.setPlaceId) {
    addReviowModal.value.setPlaceId(placeId)
  }
  // Use Bootstrap Modal API to show the modal (ensure Bootstrap JS is included)
  openRateModal();
}

// لما يضغط غير مسجّل في لينك + إضافة تقييم
const handleAddRateClick = () => {
  // نحفظ في الـ localStorage إننا عايزين نفتح مودال الإضافة بعد الرفريش
  localStorage.setItem('is_open_add_rate_modal', 'true')
  openUserModal()
}


onMounted(() => {
  if (isAuthenticated.value && authStore.user.name && props.place.is_rated == false && localStorage.getItem('is_open_add_rate_modal') === 'true') {
      setTimeout(() => {
        openAddRateModal(props.place.id);
      }, 1000);

      localStorage.removeItem('is_open_add_rate_modal');
    }else if (isAuthenticated.value && authStore.user.name && props.place.is_rated == true && localStorage.getItem('is_open_add_rate_modal') === 'true') {
      setTimeout(() => {
        showIsRatedWaringModal();
      }, 1000);

      localStorage.removeItem('is_open_add_rate_modal');
    }
})

if (authStore.user) {
  // راقب تغيير user.name
  watch(
    () => user.value.name,
    (newName, oldName) => {
      // لو اتغير من null لسلسلة نصية وجاهز تفتح مودال التقييم
      if (!oldName && newName && props.place.is_rated == false && localStorage.getItem('is_open_add_rate_modal') === 'true') {
        setTimeout(() => {
          
          openAddRateModal(props.place.id);
        }, 1000);

        localStorage.removeItem('is_open_add_rate_modal');
      }else if (!oldName && newName && props.place.is_rated == true && localStorage.getItem('is_open_add_rate_modal') === 'true') {
        setTimeout(() => {
            showIsRatedWaringModal();
        }, 1000);

        localStorage.removeItem('is_open_add_rate_modal');
      }
    }
  );
}


const sendClick =  () => {
  const response =  formsRepo.clicks(props.place.id)
}
// For demonstration purposes, assume the user is not logged in.

// Listen for the "review-added" event from the modal
const handleReviewAdded = () => {
  // Re-emit the event upward so the page can refresh reviews
  // You can use defineEmits here if PlaceProfile is set up to emit events.
  // For example:
  emit('review-added')
}

// Expose any events if needed.
const emit = defineEmits(['review-added'])

// In your real app, you might use a composable like useAuth() to check authentication.
</script>

<template>
  <div class="main-profile-inner">
    <div class="profile_logo">
      <NuxtImg
        :src="avatarUrl"
        :alt="place.name"
        loading="lazy"
        :custom="true"
        v-slot="{ src, isLoaded, imgAttrs }"
      >
        <!-- Show the actual image when loaded -->
        <img
          v-if="isLoaded"
          v-bind="imgAttrs"
          :src="src"
        >

        <!-- Show a placeholder while loading -->
        <img
          v-else
          :src="'/website/assets/img/default-featured-image.jpeg'"
        >
      </NuxtImg>
      <!-- <img loading="lazy" :src="avatarUrl" :alt="place.name" /> -->
    </div>
    <div class="profile_details">
      <!-- Hidden current place id -->
      <div style="display: none" id="current_place_view">{{ place.id }}</div>
      <h1>{{ place.name }}</h1>
      <div class="rates">
        <a class="stars" href="#latest_comments_wrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="20.303" height="19.493" viewBox="0 0 20.303 19.493">
  <path id="star-comment-alt-2" d="M11.141,24.285a1.714,1.714,0,0,1-1.016-.333,1.686,1.686,0,0,1-.591-1.866l1.589-5.1-4.028-3.27a1.685,1.685,0,0,1,1.09-2.975h5.081l1.792-4.823a1.693,1.693,0,0,1,3.178,0l1.792,4.823H25.11A1.7,1.7,0,0,1,26.7,11.85a1.73,1.73,0,0,1-.5,1.885L22.19,17l1.663,5.044a1.677,1.677,0,0,1-.573,1.866,1.7,1.7,0,0,1-1.959.074l-4.656-3.03-4.582,3.067a1.7,1.7,0,0,1-.942.277Z" transform="translate(-6.496 -4.81)" fill="#f7b32f"/>
</svg>

          <span class="rate">( {{ Number(place.total_rate_db).toFixed(1) }} )</span>
        </a>
        <div class="visitors">
          <svg id="profile-circle_linear" data-name="profile-circle/linear" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g id="vuesax_linear_profile-circle" data-name="vuesax/linear/profile-circle">
    <g id="profile-circle">
      <path id="Vector" d="M3.4,6.55a.963.963,0,0,0-.24,0,3.28,3.28,0,1,1,.24,0Z" transform="translate(8.72 6.23)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Vector-2" data-name="Vector" d="M13.48,3.945a9.934,9.934,0,0,1-6.74,2.62A9.934,9.934,0,0,1,0,3.945a3.679,3.679,0,0,1,1.77-2.58,9.73,9.73,0,0,1,9.94,0A3.679,3.679,0,0,1,13.48,3.945Z" transform="translate(5.26 15.435)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Vector-3" data-name="Vector" d="M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10Z" transform="translate(2 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Vector-4" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0"/>
    </g>
  </g>
</svg>

          <span>{{ place.rates_count_db }}</span>
        </div>
      </div>
      <div v-if="place.description">
        <p v-html="place.description"></p>
      </div>
   
      <div class="profile-place-buttons">
        <template v-if="isAuthenticated && place.is_rated == false">
          <a href="javascript:;" 
             :data-is_rated="false"
             :data-place_id="place.id"
             @click="openAddRateModal(place.id)"
             class="add_rate_btn" id="add_rate_btn">
            + اضافة تقييم
          </a>
        </template>
        <template v-else-if="isAuthenticated && place.is_rated == true">
          <a href="javascript:;" 
            @click="showIsRatedWaringModal"
             class="add_rate_btn" id="add_rate_btn">
            + اضافة تقييم
          </a>
        </template>
        <template v-else>
             
          <a href="javascript:;" @click="handleAddRateClick" id="add_rate_btn_login" data-is_place="rate_place" class="add_rate_btn">
            + اضافة تقييم
          </a>
        </template>

        <template v-if="place.button?.active">
             
            <a :href="place.button?.url" @click="sendClick" class="btn_secondary" target="_blank">
              {{place.button?.text}}
            </a>
        </template>
      </div>
    </div>
      <!-- Include the modal component with a ref -->
    </div>
    <AddReviowModal ref="addReviowModal" @review-added="handleReviewAdded" />
</template>
